import React from 'react';
import { connect } from 'react-redux';

const mapStateToProps = (state: any) => ({
	userType: state.session.userType,
});

export function withUserType(Component: React.ComponentType<any>) {
	return connect(mapStateToProps)(Component);
}
